export default {
  can: true,
  run: function () {
    document.querySelectorAll('[data-scroll-to="search"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault()
        var target = document.querySelector('#search')
        if (!target) return
        var header = document.querySelector('.site-header')
        var headerHeight = header ? header.offsetHeight : 0
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 24
        window.scrollTo({ top: y, behavior: 'smooth' })
      })
    })
  }
}
